import i18n from "../../resources/I18n";
import { DsdModale } from "../DSD/DsdModale";
import { INavigationParcours, obtenirNavigationUrl } from "../../util/Navigation";
import FonctionUtilitaire from "../utils/FonctionUtilitaire";
import { CybermetriesAMC } from "../../util/CybermetrieAMC";
import { useCybermetrieAMCContext } from "../utils/CybermetrieAMCContext";

interface IModaleEnregistrerProps {
  modaleOuvert: boolean;
  onClickModaleEnregistrerFermer: Function;
  dateExpirationOffre?: Date;
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
}

function retournerJourEtMoisEcheanceHTML(date?: Date) {
  let dateEcheance = new Date(date);
  let dateFormater;
  if (i18n.language === "en") {
    dateFormater = FonctionUtilitaire.dateToJJMois(dateEcheance, "en");
  } else {
    dateFormater = FonctionUtilitaire.dateToJJMois(dateEcheance, "fr");
  }
  return `<b>${dateFormater}</b>`;
}

function retournerAnneEcheance(date?: Date) {
  let dateEcheance = new Date(date);
  return FonctionUtilitaire.dateToAAAA(dateEcheance);
}

function ModaleEnregistrer(props: Readonly<IModaleEnregistrerProps>) {
  const cybermetrieParams = useCybermetrieAMCContext();
  const onClickBoutonEnregistrer = () => {
    CybermetriesAMC.EnvoieEnregistrerQuitterAMC(cybermetrieParams);
    window.location.href = `${obtenirNavigationUrl(props.cookieParcoursAssurance.idCallback)}${props.parcours}/${
      props.cookieParcoursAssurance.langue
    }/saveandquit?idSouscription=${props.cookieParcoursAssurance.idSouscription}&idAssure=${
      props.cookieParcoursAssurance.idAssure
    }`;
  };

  return (
    <DsdModale
      id="dsd-modal-enregistrer"
      dataTestId="dsd-modal-enregistrer"
      show={props.modaleOuvert}
      buttonPrimaryLabel={i18n.t("amc:bouton-principal-modale-enregistrer-et-quitter")}
      buttonSecondaryLabel={i18n.t("amc:bouton-secondaire-modale-enregistrer-et-quitter")}
      dsdModalSecondaryClick={props.onClickModaleEnregistrerFermer}
      dsdModalPrimaryClick={onClickBoutonEnregistrer}
      spanSlotTitle={i18n.t("amc:titre-modale-enregistrer-et-quitter")}
    >
      <p>
        <span dangerouslySetInnerHTML={{ __html: i18n.t("amc:prefix-texte-modale-enregistrer-et-quitter") }}></span>
        <span dangerouslySetInnerHTML={{ __html: retournerJourEtMoisEcheanceHTML(props.dateExpirationOffre) }} />
        <span>{retournerAnneEcheance(props.dateExpirationOffre)}</span>
        <span dangerouslySetInnerHTML={{ __html: i18n.t("amc:sufix-texte-modale-enregistrer-et-quitter") }}></span>
      </p>
    </DsdModale>
  );
}

export default ModaleEnregistrer;
